export type Material = {
  number: number;
  emoji: string;
  title: string;
  pages: string;
  tagline: string;
  intro: string;
  topics: string[];
  closing: string;
  image: string;
  accent: 'teal' | 'navy' | 'coral';
};

export const materials: Material[] = [{
  number: 1,
  emoji: '📘',
  title: 'CATEQUESIS 1',
  pages: '40 páginas para comenzar el camino',
  tagline: 'Un recorrido para conocer, comprender y empezar a vivir la fe cristiana.',
  intro: 'Actividades para trabajar:',
  topics: ['Dios nos ama', 'La Creación', 'Creados a imagen de Dios', 'La Biblia', 'Cómo buscar citas bíblicas', 'Historia de la Salvación', 'Abraham y Moisés', 'María', 'Quién es Jesús', 'Discípulos y parábolas', 'El Buen Samaritano', 'Las Bienaventuranzas', 'La oración', 'Padre Nuestro y Ave María', 'Iglesia y Misa', 'Los Sacramentos', 'La Eucaristía'],
  closing: 'Una base completa para empezar a descubrir la fe.',
  image: 'https://cdn.magicpatterns.com/uploads/cfjUwwSpZXsp11xY9dSVxW/CATEQUESIS_1_(1).png',
  accent: 'teal'
}, {
  number: 2,
  emoji: '📗',
  title: 'CATEQUESIS 2',
  pages: '45 páginas para seguir creciendo y prepararse para recibir a Jesús',
  tagline: 'Los chicos trabajan la relación entre fe, decisiones y vida cotidiana, profundizan en la Reconciliación y la Eucaristía y avanzan hacia la Primera Comunión.',
  intro: 'Incluye actividades sobre:',
  topics: ['Seguir a Jesús', 'Elegir el bien', 'Libertad y responsabilidad', 'Conciencia', 'Los Diez Mandamientos', 'Respeto y cuidado de los demás', 'Verdad y honestidad', 'Perdón y reconciliación', 'Examen de conciencia', 'Sacramento de la Reconciliación', 'Pasión, Muerte y Resurrección', 'Última Cena', 'La Eucaristía', 'Partes de la Misa', 'Cómo acercarse a comulgar', 'Preparación del corazón', 'Primera Comunión'],
  closing: 'No termina en “aprender”: prepara para un verdadero encuentro con Jesús.',
  image: 'https://cdn.magicpatterns.com/uploads/sbUYwrwLxVt1icotXGHZWR/CATEQUESIS_2.png',
  accent: 'navy'
}, {
  number: 3,
  emoji: '🔥',
  title: 'CONFIRMACIÓN',
  pages: '35 páginas para profundizar la fe y llevarla a la vida',
  tagline: 'El recorrido ayuda a comprender quién es el Espíritu Santo, cómo actúa y qué significa asumir personalmente la fe recibida.',
  intro: 'Actividades sobre:',
  topics: ['El Bautismo', 'La Santísima Trinidad', 'El Espíritu Santo', 'Pentecostés', 'Los 7 dones del Espíritu Santo', 'Los frutos del Espíritu', 'Qué es la Confirmación', 'La celebración', 'El Santo Crisma', 'Imposición de manos', 'Padrino y madrina', 'Dudas y preguntas de fe', 'Talentos y misión', 'Ser testigos de Jesús', 'Servicio', 'Iglesia y comunidad', 'Eucaristía y Reconciliación', 'El compromiso después de confirmarse'],
  closing: 'Confirmarse no es terminar Catequesis. Es empezar a vivir la fe de una manera más personal y comprometida.',
  image: 'https://cdn.magicpatterns.com/uploads/oLwRhhsteB7rjYa1J55bQ4/CONFIRMACION_(1).png',
  accent: 'coral'
}];

export const bonus = {
  title: 'ESI PARA ESCUELA CATÓLICA',
  pages: '42 páginas',
  tagline: 'Para trabajar afectividad, sexualidad, dignidad, vínculos y proyecto de vida desde una mirada católica.',
  intro: 'Incluye actividades sobre:',
  body: 'Está especialmente pensado para abordar temas que muchas veces son difíciles de trabajar con adolescentes, manteniendo una mirada integral y coherente con la enseñanza católica.',
  topics: ['Persona y dignidad humana', 'Identidad personal', 'Cuerpo y afectividad', 'Amistades y vínculos', 'Enamoramiento', 'Noviazgo y relaciones estables', 'Celos y control', 'Límites', 'Sexualidad desde una mirada integral', 'Amor y responsabilidad', 'Presiones sexuales', 'Elegir esperar', 'Libertad y decisiones', 'Actos humanos y moralidad', 'Conciencia', 'Virtudes cardinales', 'Virtudes teologales', 'Reconocer señales de abuso', 'Pedir ayuda', 'Valor de la vida humana', 'Embarazo inesperado', 'Aborto desde la mirada católica', 'Adicciones', 'Presión del grupo', 'Proyecto de vida'],
  closing: 'Un recurso especialmente valioso para quienes acompañan adolescentes.',
  image: 'https://cdn.magicpatterns.com/uploads/1FniExf4po2kKCxAZbmPND/bonus_esi.png'
};

export const journey = [{
  title: 'CATEQUESIS 1',
  description: 'Conocer · descubrir · comenzar.',
  accent: 'teal'
}, {
  title: 'CATEQUESIS 2',
  description: 'Profundizar · reconciliarse · prepararse para la Eucaristía.',
  accent: 'navy'
}, {
  title: 'CONFIRMACIÓN',
  description: 'Elegir · comprometerse · servir · dar testimonio.',
  accent: 'coral'
}];

export const workFormats = [{
  emoji: '💭',
  title: 'PENSAR',
  description: 'Preguntas que parten de su propia realidad.'
}, {
  emoji: '✍️',
  title: 'ESCRIBIR',
  description: 'Actividades con espacios para desarrollar respuestas.'
}, {
  emoji: '📖',
  title: 'COMPRENDER',
  description: 'Explicaciones claras y visuales.'
}, {
  emoji: '💬',
  title: 'DIALOGAR',
  description: 'Situaciones que permiten conversar y compartir.'
}, {
  emoji: '❤️',
  title: 'LLEVAR LA FE A SU VIDA',
  description: 'No quedarse solamente con conceptos.'
}];

export const audiences = [{
  emoji: '👩‍🏫',
  label: 'Catequistas'
}, {
  emoji: '⛪',
  label: 'Parroquias y comunidades'
}, {
  emoji: '🏫',
  label: 'Docentes de escuelas católicas'
}, {
  emoji: '📚',
  label: 'Profesores de formación religiosa'
}, {
  emoji: '🧑‍🏫',
  label: 'Coordinadores de Catequesis'
}, {
  emoji: '🙏',
  label: 'Preparación para Primera Comunión'
}, {
  emoji: '🕊️',
  label: 'Preparación para Confirmación'
}];
